import {
  ADD_NOTIFICATION,
  LOAD_NOTIFICATIONS,
  MARK_ALL_NOTIFICATIONS_READ,
  MARK_NOTIFICATION_READ,
  DELETE_ALL_NOTIFICATIONS,
} from "../../actions/types";

const initialState = {
  notifications: [],
  unreadCount: 0,
};

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_NOTIFICATIONS: {
      const notifications = action.payload || [];
      const unreadCount = notifications.filter((n) => !n.isRead).length;
      return { ...state, notifications, unreadCount };
    }
    case ADD_NOTIFICATION: {
      const updated = [action.payload, ...state.notifications];
      return {
        ...state,
        notifications: updated,
        unreadCount: state.unreadCount + 1,
      };
    }
    case MARK_ALL_NOTIFICATIONS_READ:
      return {
        ...state,
        notifications: state.notifications.map((n) => ({ ...n, isRead: true })),
        unreadCount: 0,
      };
    case MARK_NOTIFICATION_READ:
      return {
        ...state,
        notifications: state.notifications.map((n) =>
          n.id === action.payload ? { ...n, isRead: true } : n
        ),
        unreadCount: Math.max(0, state.unreadCount - 1),
      };
    case DELETE_ALL_NOTIFICATIONS:
      return { ...state, notifications: [], unreadCount: 0 };
    default:
      return state;
  }
};

export default notificationsReducer;

